import { Component, EventEmitter, Input, OnInit, Output } from "@angular/core";
import { AppService } from "src/app/core/services/app.service";
import { FocuslinkService } from "src/app/core/services/focuslink.service";
import { OOVenueService } from "src/app/core/services/venue-service";
import { GiftCardDto } from "src/app/shared/models/DTO/gift-card.dto";

@Component({
	selector: "app-gift-card-record",
	templateUrl: "./gift-card-record.component.html",
	styleUrls: ["../../../../../commandcenter.scss"],
})
export class GiftCardRecordComponent implements OnInit {
	@Input() cardSelected: GiftCardDto;
	@Output() cardSelectedChange = new EventEmitter<GiftCardDto>();

	adjustmentValue: number;

	constructor(public app: AppService, public venueService: OOVenueService, private focuslink: FocuslinkService) {}

	ngOnInit(): void {
		this.getTransactions(this.venueService.subscriptionVenue.value.key, +this.cardSelected.GiftCardID);
	}

	async getTransactions(venueKey: number, giftcardId: number) {
		const resp = await this.focuslink.giftCardGetOne(venueKey, giftcardId);
		this.cardSelected = new GiftCardDto(resp);
	}

	async deleteCard() {}
}
